var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"esg_risk_bar_chart"}},[_c('div',{staticClass:"risk-chart-y-title"},[_vm._v(_vm._s(_vm.$t('insurance.risk_rating')))]),_vm._v(" "),_c('div',{staticClass:"risk-chart-y-title"},[_vm._v(_vm._s(_vm.$t('insurance.loss_ratio')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfdaa466","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/insurance_esg/components/InsuranceESGBarChart.vue
// module id = null
// module chunks = 